import { PureComponent } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import i18n from 'services/i18n'

import s from './Switch.module.scss'

class Switch extends PureComponent {
  state = {
    selected: this.props.input.value || this.props.defaultValue,
    anim: false
  }

  static getDerivedStateFromProps (props, prevState) {
    if (props.input.value !== prevState.selected) return { selected: props.input.value, anim: true }

    return prevState
  }

  onChange = () => {
    const { input: { onChange, disabled } } = this.props
    if (disabled) return
    const { selected } = this.state
    this.setState({ selected: !selected, anim: true })
    onChange && onChange(!selected)
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.onChange()
    }
  }

  render () {
    const { selected, anim } = this.state
    const { label, input: { disabled, name }, borderBottom, labelOn, labelOff, className } = this.props
    const switchId = `switch-${name || 'default'}`

    return (
      <div className={cn(s.container, borderBottom && s.borderBottom, disabled && s.disabled, className)}>
        <span className={s.label} id={switchId}>{label}</span>
        <button
          type="button"
          role="switch"
          aria-checked={selected}
          aria-labelledby={switchId}
          disabled={disabled}
          onClick={this.onChange}
          onKeyDown={this.onKeyDown}
          className={s.switchButton}
        >
          <span className={s.switchWrapper}>
            <span className={cn(
              s.oval,
              anim && s.withAnim,
              selected ? s.selected : s.unselected
            )}>
              {selected ? labelOn : labelOff}
            </span>
          </span>
        </button>
      </div>
    )
  }
}

Switch.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func
  }).isRequired,
  label: PropTypes.string.isRequired
}

Switch.defaultProps = {
  borderBottom: true,
  labelOn: i18n.t('verify.yes'),
  labelOff: i18n.t('verify.no')
}

export { Switch }
